export default __webpack_public_path__ + "static/menstruacionMb-c578d1c49ea75b44c986fc14d53ec6ac.png";